import React, { Component, PropTypes } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Project from '../components/Project';

import { connect } from 'react-redux';
const { Link } = require('react-router')

//Change Class per Project
class CreativeBoost extends React.Component {
  render () {
    const { projects, benchmark, personalInfo } = this.props;  
    console.log(personalInfo);
    
    const featProject = projects[3];

    // const params = this.props.params || {}
    // const { title, description, year, poster, trailer } = params
    return (
      <div className='container'>
        <Header personalInfo={personalInfo} />
        <div className=''>

           <div className='back-button'>
          <Link to='/'>
          <span className="glyphicon glyphicon-chevron-left"></span>
            Back to projects
          </Link>
          </div>

          <Project project={featProject}/>


        </div>

         <div className='case-study col-md-12 col-xs-12'>
         <h4>Overview</h4>




<p>
This is a simple anagram puzzle solving game I used to test the capabilities of Angular Js.  It uses the $scope, $http, $watch, and $timeout angular services.
</p>


<p>
What really blew me away about Angular was its quick set up and start time.  It is a more traditional development environment that React, much easier to get up and running with than JSX and components.  


Angular makes it very easy to use and manipulate list elements and I was able to build the entire project javascript file in less than 100 lines of code.
</p>


<h4>
Cool Parts
</h4>


<p>
I used ng-repeat to display the anagrams and was able to easily use ng-bind and the $index service to compare, on keyup, user submitted input with the correct answer.  This allowed a more seamless experience since there was no need to ever submit the input, just type the correct answer and the input field will fade out and disable itself.
</p>


<pre>{`


<!--load list via Angular -->


              <ul>
                <li ng-repeat="questions in anagrams track by $index">


                  <div class="row">  


                      <div class="small-4 columns"> 
                      <!-- Controller Logic Connector -->
                        <input 
                          type="text" 
                          id="answer" 
                          ng-model="questions.guess" 
                          ng-keyup="checkAnswer($index)" 
                          ng-disabled="questions.match">
                        </input>  
                      </div> 


                      <!-- Load Question from Array -->
                      <div class="small-4 columns">  
                          {{questions.mixed}} 
                      </div>


               …
`}</pre> 




<p>
Logic to check each anagram.  Angular made this really easy to handle thanks to the $index service.


</p>


<pre>{`
//Check to see if the guess matches the answer (on keyup)
    $scope.checkAnswer = function(id) {
        //Convert to uppercase
        var guess = $scope.anagrams[id].guess.toUpperCase();
        var answer = $scope.anagrams[id].solved.toUpperCase();
        
        //Compare guess with correct answer
        if(guess == answer) {
          //Set match variable
          $scope.anagrams[id].match = true;
          //increment score
          $scope.score++;
        }   else {
          //scope.correctAns = false;
        }
    };


`}</pre> 


<h4>
Issues
</h4>


<p>
The main issue I had was working with the timer.  I used the $timeout service and a custom filter to render the minutes and seconds.  For some reason, the time would skip ahead a couple seconds which makes me wonder how the DOM is being rendered and if there is some type of delay or perhaps a mathematical error with seconds getting truncated.


In the future I would use a library like countdown.js to handle this feature.
</p>

         </div>

        <Footer personalInfo={personalInfo} />
      </div>
    )
  }
}

const { object, array } = React.PropTypes

CreativeBoost.propTypes = {
  projects: PropTypes.array.isRequired,
  personalInfo: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    projects: state.projects,
    personalInfo: state.personalInfo
  };
}

//Change for each project

export default connect(mapStateToProps)(CreativeBoost)




/** WEBPACK FOOTER **
 ** ./src/pages/CreativeBoost.js
 **/